import React, { useState, useEffect } from 'react';
import { AiFillAlert } from "react-icons/ai";
import { Product } from "../../../types/types";

interface ReportModalProps {
  closeReportModal: () => void;
  product?: Product;
}

const reportReasons = [
  "부적절한 홍보 게시글",
  "음란성 또는 청소년에게 부적합한 내용",
  "저작권 침해",
  "사기/거짓 광고",
  "기타 허위 정보",
  "기타"
];

export default function ReportModal({ closeReportModal, product }: ReportModalProps) {
  const [selectedReason, setSelectedReason] = useState<string | null>(null);
  const [otherReason, setOtherReason] = useState<string>('');

  useEffect(() => {
    // 모달이 열릴 때 배경 스크롤 방지
    document.body.style.overflow = 'hidden';
    return () => {
      // 모달이 닫힐 때 배경 스크롤 복원
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedReason(e.target.value);
  };

  const handleOtherReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtherReason(e.target.value);
  };

  const handleReport = () => {
    if (selectedReason === '기타' && otherReason.trim() === '') {
      alert("기타 사유를 입력해주세요.");
      return;
    }

    const finalReason = selectedReason === '기타' ? otherReason : selectedReason;
    console.log('Reported product:', product);
    console.log('Report reason:', finalReason);
    closeReportModal();
  };

  return (
    <div className="p-8 mobile:p-5 w-[500px] mobile:w-full rounded-2xl">
      {/* 헤더 섹션 */}
      <div className="flex items-center justify-between mb-8 mobile:mb-6">
        <h3 className="Pretendard-Bold text-2xl mobile:text-xl text-gray-900">
          신고하기
        </h3>
        <AiFillAlert className="text-red-500 text-2xl mobile:text-xl" />
      </div>

      {/* 메인 컨텐츠 */}
      <div className="space-y-6">
        <div>
          <h4 className="Pretendard-SemiBold text-gray-700 text-lg mobile:text-base mb-2">
            신고 사유
          </h4>
          <p className="text-gray-500 text-sm mobile:text-xs mb-4">
            여러 사유에 해당되는 경우, 대표적인 사유 1개를 선택해 주세요.
          </p>

          <div className="grid gap-3 mobile:gap-2">
            {reportReasons.map((reason, index) => (
              <label
                key={index}
                className={`flex items-center p-4 mobile:p-3 rounded-xl cursor-pointer transition-all
                  ${selectedReason === reason 
                    ? 'bg-red-50 border-2 border-red-500' 
                    : 'bg-gray-50 border-2 border-transparent hover:bg-gray-100'
                  }`}
              >
                <input
                  type="radio"
                  name="reportReason"
                  value={reason}
                  checked={selectedReason === reason}
                  onChange={handleReasonChange}
                  className="hidden"
                />
                <span className={`text-base mobile:text-sm ${
                  selectedReason === reason ? 'text-red-500 font-semibold' : 'text-gray-700'
                }`}>
                  {reason}
                </span>
              </label>
            ))}
          </div>
        </div>

        {/* 기타 사유 입력 필드 */}
        {selectedReason === '기타' && (
          <div className="mt-4">
            <input
              type="text"
              value={otherReason}
              onChange={handleOtherReasonChange}
              className="w-full p-4 bg-gray-50 border-2 border-gray-200 rounded-xl 
                focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none
                text-gray-700 placeholder-gray-400"
              placeholder="기타 사유를 자세히 작성해주세요"
            />
          </div>
        )}
      </div>

      {/* 버튼 그룹 */}
      <div className="flex gap-3 mt-8 mobile:mt-6">
        <button
          className="flex-1 p-4 mobile:p-3 bg-red-500 text-white rounded-xl 
            hover:bg-red-600 transition-colors duration-200
            disabled:opacity-50 disabled:cursor-not-allowed
            Pretendard-SemiBold text-base mobile:text-sm"
          onClick={handleReport}
          disabled={!selectedReason || (selectedReason === '기타' && otherReason.trim() === '')}
        >
          신고하기
        </button>
        <button
          className="flex-1 p-4 mobile:p-3 bg-gray-100 text-gray-700 rounded-xl 
            hover:bg-gray-200 transition-colors duration-200
            Pretendard-SemiBold text-base mobile:text-sm"
          onClick={closeReportModal}
        >
          취소
        </button>
      </div>
    </div>
  );
}
